import _Upload from "@arco-design/web-react/es/Upload";
import _useUpdateEffect from "@byted/hooks/es/useUpdateEffect";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useRef, useState, useImperativeHandle, forwardRef } from 'react';
import ArcoImgCropper from '@byted-vcloud-material/arco-img-cropper';
import VcloudUploader from 'vcloud-uploader';
import { getUploadToken } from '@api/common';
import { IconDelete, IconEdit } from '@arco-design/web-react/icon';
import useLocale from '@src/hooks/useLocale';
function CommonUpload(props, ref) {
  var _this = this;
  var _a;
  var tokenRef = useRef();
  var uploadRef = useRef(null);
  var resolveRef = useRef();
  var t = useLocale().t;
  var vcloudUploader = new VcloudUploader({
    userId: (_a = window.__user__) === null || _a === void 0 ? void 0 : _a.username,
    appId: 4374,
    imageConfig: {
      serviceId: '32wkljvsoj'
    }
  });
  var accept = props.accept || 'image/*';
  var _b = __read(useState(props.value ? {
      uid: '-1',
      status: 'done',
      url: props.value
    } : null), 2),
    file = _b[0],
    setFile = _b[1];
  _useUpdateEffect(function () {
    if (props.value && props.value !== (file === null || file === void 0 ? void 0 : file.uid)) {
      setFile({
        uid: '-1',
        status: 'done',
        url: props.value
      });
    }
  }, [props.value]);
  useImperativeHandle(ref, function () {
    return {
      submit: function submit() {
        return new Promise(function (resolve) {
          if (file && file.status !== 'done') {
            uploadRef.current && uploadRef.current.submit(file);
            resolveRef.current = resolve;
          } else if (file && file.url) {
            resolve(file.url);
          } else {
            resolve('');
          }
        });
      }
    };
  }, [file]);
  return /*#__PURE__*/React.createElement(ArcoImgCropper, {
    aspectRatio: props.drag ? 16 / 9 : 4 / 4,
    cropperModalProps: {
      title: t['common.upload.title']
    },
    controlBar: {
      scale: {
        showActionIcon: true
      }
    }
  }, /*#__PURE__*/React.createElement(_Upload, __assign({
    accept: accept,
    listType: "picture-card"
  }, props, {
    showUploadList: false,
    onRemove: function onRemove() {
      return setFile(null);
    },
    fileList: file ? [file] : [],
    beforeUpload: function beforeUpload(file) {
      return __awaiter(_this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4, getUploadToken()];
            case 1:
              data = _a.sent();
              tokenRef.current = data;
              return [2, file];
          }
        });
      });
    },
    onProgress: setFile,
    onChange: function onChange(_, file) {
      return __awaiter(_this, void 0, void 0, function () {
        var newFile, uri;
        return __generator(this, function (_a) {
          newFile = __assign(__assign({}, file), {
            url: URL.createObjectURL(file.originFile)
          });
          if (file.status === 'done') {
            uri = file.response && file.response.uploadResult['Uri'];
            resolveRef.current && resolveRef.current(uri);
            resolveRef.current = undefined;
            newFile.uid = uri;
            props.onChange && props.onChange(uri);
          }
          setFile(newFile);
          return [2];
        });
      });
    },
    customRequest: function customRequest(options) {
      if (tokenRef.current && options.file) {
        var fileKey = vcloudUploader.addFile({
          file: options.file,
          stsToken: tokenRef.current,
          type: 'image'
        });
        vcloudUploader.on('progress', function (info) {
          options.onProgress(info.percent);
        });
        vcloudUploader.on('complete', function (info) {
          options.onSuccess(info);
        });
        vcloudUploader.on('error', function (info) {
          options.onError(info);
        });
        vcloudUploader.start(fileKey);
      }
    }
  }), file && file.url ? props.drag ? /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/React.createElement("img", {
    style: {
      width: '100%'
    },
    src: file.url
  }), !props.disabled && /*#__PURE__*/React.createElement("div", {
    className: "arco-upload-list-item-picture-mask"
  }, /*#__PURE__*/React.createElement(IconEdit, null), /*#__PURE__*/React.createElement(IconDelete, {
    style: {
      marginLeft: 12
    },
    onClick: function onClick(e) {
      e.stopPropagation();
      setFile(null);
      props.onChange && props.onChange('');
    }
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "arco-upload-list-item-picture"
  }, /*#__PURE__*/React.createElement("img", {
    style: {
      width: '100%'
    },
    src: file.url
  }), !props.disabled && /*#__PURE__*/React.createElement("div", {
    className: "arco-upload-list-item-picture-mask"
  }, /*#__PURE__*/React.createElement(IconEdit, null), /*#__PURE__*/React.createElement(IconDelete, {
    style: {
      marginLeft: 12
    },
    onClick: function onClick(e) {
      e.stopPropagation();
      setFile(null);
      props.onChange && props.onChange('');
    }
  }))) : undefined));
}
export default /*#__PURE__*/forwardRef(CommonUpload);